<div class="cell auto cell-block-y" *ngIf="parameters">
    <form #initialBalanceSheetForm="ngForm">
        <kiwi-parameters-tab-content-header [titleLabelKey]="'parameters.financial.initial.balance.sheet.title'"
                                            [saveDisabled]="areParametersReadonly() || initialBalanceSheetForm.invalid"
                                            (saved)="updateParameters()"></kiwi-parameters-tab-content-header>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p [i18nKey]="'parameters.financial.initial.balance.sheet.description'"></p>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <table class="_tableColor">
            <tbody>
            <tr>
                <td [i18nKey]="'parameters.financial.initial.balance.sheet.initial.capital'"></td>
                <td>
                    <kiwi-currency-input
                        [(ngModel)]="parameters.initialCapital"
                        [disabled]="areParametersReadonly()"
                        name="initialCapital">
                    </kiwi-currency-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.financial.initial.balance.sheet.intangible.asset'"></td>
                <td>
                    <kiwi-currency-input
                        [(ngModel)]="parameters.intangibleAsset"
                        [disabled]="areParametersReadonly()"
                        name="intangibleAsset">
                    </kiwi-currency-input>
                </td>
            </tr>
            </tbody>
        </table>
    </form>
</div>
